export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-500.d450a4de.woff2";